<template>
  <div class="distribution-svg">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="459.533"
      height="376.013"
      viewBox="0 0 459.533 376.013"
    >
      <g transform="translate(-1337 -1783.987)">
        <text
          transform="translate(1527 2155)"
          fill="#010101"
          font-size="14"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">（单位：人）</tspan>
        </text>
        <text
          transform="translate(1676 2020)"
          fill="#010101"
          font-size="14"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[1].text }}</tspan>
        </text>
        <text
          transform="translate(1385 2020)"
          fill="#010101"
          font-size="14"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[2].text }}</tspan>
        </text>
        <text
          transform="translate(1531 2020)"
          fill="#010101"
          font-size="14"
          font-family="PingFangSC-Regular, PingFang SC"
          letter-spacing="0.05em"
        >
          <tspan x="0" y="0">{{ sortArr[0].text }}</tspan>
        </text>

        <path
          d="M356,442.5C378.981,359.169,393.952,292,440.767,292s60.843,67.03,84.767,150.5Z"
          transform="translate(1271 1537.496)"
          fill="#8b72b1"
          opacity="0.8"
        />
        <path
          d="M356,488.013C378.981,379.48,393.952,292,440.767,292s60.843,87.3,84.767,196.013Z"
          transform="translate(1127 1491.987)"
          fill="#dcc4a1"
          opacity="0.8"
        />
        <path
          d="M356,384.24C378.981,333.166,393.952,292,440.767,292s60.843,41.081,84.767,92.24Z"
          transform="translate(981 1595.76)"
          fill="#eb6580"
          opacity="0.8"
        />

        <rect
          width="60"
          height="30"
          rx="15"
          transform="translate(1392 2038)"
          fill="#eb6580"
        />
        <rect
          width="60"
          height="30"
          rx="15"
          transform="translate(1538 2038)"
          fill="#dcc4a1"
        />
        <rect
          width="60"
          height="30"
          rx="15"
          transform="translate(1682 2038)"
          fill="#8b72b1"
        />
        <text
          transform="translate(1408 2058)"
          fill="#fff"
          font-size="14"
          font-family="Arial-BoldMT, Arial"
          font-weight="700"
        >
          <tspan x="18" y="0" text-anchor="middle">
            {{ sortArr[2].percentage }}%
          </tspan>
        </text>
        <text
          transform="translate(1554 2058)"
          fill="#fff"
          font-size="14"
          font-family="Arial-BoldMT, Arial"
          font-weight="700"
        >
          <tspan x="18" y="0" text-anchor="middle">
            {{ sortArr[0].percentage }}%
          </tspan>
        </text>
        <text
          transform="translate(1698 2058)"
          fill="#fff"
          font-size="14"
          font-family="Arial-BoldMT, Arial"
          font-weight="700"
        >
          <tspan x="18" y="0" text-anchor="middle">
            {{ sortArr[1].percentage }}%
          </tspan>
        </text>
        <text
          transform="translate(1409 1918)"
          fill="#fff"
          font-size="14"
          font-family="Helvetica"
          letter-spacing="0.05em"
        >
          <tspan x="12" y="0" text-anchor="middle">
            {{ sortArr[2].num }}
          </tspan>
        </text>
        <text
          transform="translate(1555 1822)"
          fill="#fff"
          font-size="14"
          font-family="Helvetica"
          letter-spacing="0.05em"
          text-anchor="middle"
        >
          <tspan x="12" y="0" text-anchor="middle">
            {{ sortArr[0].num }}
          </tspan>
        </text>
        <text
          transform="translate(1699 1865)"
          fill="#fff"
          font-size="14"
          font-family="Helvetica"
          letter-spacing="0.05em"
        >
          <tspan x="12" y="0" text-anchor="middle">
            {{ sortArr[1].num }}
          </tspan>
        </text>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'DistributionSvg',
  props: {
    vipDistributionData: {
      type: Array
    }
  },
  data() {
    return {}
  },
  computed: {
    sortArr() {
      return this.vipDistributionData.sort(this.utils._compare('num', 'des'))
    }
  }
}
</script>
<style lang="scss" scoped>
.distribution-svg {
}
</style>
